export default __webpack_public_path__ + "static/media/close-X.eeb7616d.svg";